import { Select } from 'antd';

import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';
import { masterDataKeys } from 'features/lost-found-management/keys';
import { appApiMasterIndices } from 'configs/variables';

const { Option } = Select;

export function SpSelectStatusLostFound(props) {
  const { data, isLoading } = useSpSelectStatusLostFound({ groupId: props?.groupId });

  return (
    <Select {...props} placeholder="เลือกสถานะ" loading={isLoading}>
      {data?.map((ss, index) => (
        <Option key={index} value={ss.id}>
          {ss.label_en}
        </Option>
      ))}
    </Select>
  );
}

export function useSpSelectStatusLostFound({ groupId }) {
  const { get } = useHttpClient();
  const queryRequest = useQuery({
    queryKey: masterDataKeys.selectLostFoundStatus.queryKey,
    queryFn: async () =>
      await get({
        url: `${appApiMasterIndices}/lost_and_found/status`,
      }),
    select: (res) => {
      const { response } = res;
      const finalSource = response?.data && response?.data?.length > 0 ? response?.data : [];
      try {
        const filters = finalSource.filter((ss) => ss.group_id === groupId);
        return filters;
      } catch (error) {
        return [];
      }
    },
  });

  const lookup = (id = '') => {
    try {
      const finds = queryRequest.data.find((ss) => ss.id === id);
      return finds;
    } catch (error) {
      return null;
    }
  };

  return {
    ...queryRequest,
    lookup,
  };
}
